/* Domovoi · hand-offs to a product (D2.6).

   The app shell decides where a shared link goes ("save this as a recipe"),
   then opens that product's tab and leaves it an intent. The product picks it
   up when it mounts, or straight away if it is already open. One pending
   intent per product; anything older than two minutes is dropped.

   Side-effect free: products may import it (see AGENTS.md). */
const TTL = 120000;
const box = () => (typeof window === 'undefined' ? {} : (window.__dvIntents = window.__dvIntents || {}));

export function sendIntent(product, data) {
  box()[product] = { ...data, at: Date.now() };
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('dv-intent', { detail: { product } }));
}

export function takeIntent(product) {
  const q = box(), d = q[product];
  delete q[product];
  return d && Date.now() - d.at < TTL ? d : null;
}

/* Calls fn(intent) for this product now (if one is waiting) and whenever a
   new one arrives. Returns the unsubscribe. */
export function onIntent(product, fn) {
  const h = (e) => { if (e.detail && e.detail.product === product) { const d = takeIntent(product); if (d) fn(d); } };
  window.addEventListener('dv-intent', h);
  const waiting = takeIntent(product);
  if (waiting) setTimeout(() => fn(waiting), 0);
  return () => window.removeEventListener('dv-intent', h);
}
